// src/components/shared/form/utils.ts

function isPlainObject(value: unknown): value is Record<string, unknown> {
  return Boolean(value) && Object.prototype.toString.call(value) === "[object Object]";
}

export function trimStringValues<T>(value: T): T {
  if (typeof value === "string") {
    return value.trim() as T;
  }

  if (Array.isArray(value)) {
    return value.map(trimStringValues) as T;
  }

  if (isPlainObject(value)) {
    return Object.fromEntries(
      Object.entries(value).map(([key, entry]) => [trimStringValues(key), trimStringValues(entry)])
    ) as T;
  }

  return value;
}
